import { useMemo } from 'react';
import type { TrendRow } from '../Model/CostType';

export type TrendChartRecord = Record<string, string | number>;

export function useTrendData(trend?: TrendRow[]): TrendChartRecord[] {
  return useMemo(() => {
    if (!trend || !Array.isArray(trend)) return [];
    const map = new Map<string, TrendChartRecord>();
    for (const row of trend) {
      if (!map.has(row.Date)) map.set(row.Date, { date: row.Date });
      const record = map.get(row.Date)!;
      const current = (record[row.GroupValue] as number | undefined) ?? 0;
      record[row.GroupValue] = current + row.Cost;
    }
    return Array.from(map.values()).sort((a, b) =>
      String(a.date).localeCompare(String(b.date)),
    );
  }, [trend]);
}
